exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.loading-box[data-v-72ebe06a]{\n    min-height: 100px;\n}\n", ""]);

